import React, { useEffect } from 'react';
import PageWithTitleLayout from '../Layout/PageWithTitleLayout';
import { 
    Tab,
    Box
} from '@mui/material'
import {
    TabContext,
    TabList,
} from '@mui/lab'
import AdminUserManagements from './AdminUserManagements';
import AdminUserManagementEdit from './AdminUserManagementEdit';
import AdminUserBulkUpload from './AdminUserBulkUpload';
import AdminStoreManagements from './AdminStoreManagements';
import AdminUserManagementList from './AdminUserManagementList';
import AdminStoreBulkUpload from './AdminStoreBulkUpload';
import AdminHLG from './AdminHLG';
import { useStickyString } from '../../Utilities/useStickyState';
import { PATHS } from '../../constants';
import { Route, Switch } from 'react-router-dom';

const AdminSettings = ({ history }) => {
    const [tabValue, setTabValue] = useStickyString('userManagement', 'frederickAdminSettingsTabValue')
    
    useEffect(() => {
        if(history.location.pathname.includes('storeManagement')) {
            setTabValue('storeManagement')
        } else if(history.location.pathname.includes('hlg')) {
            setTabValue('hlg')
        } else {
            setTabValue('userManagement')
        }
    }, [history.location.pathname, setTabValue])
    
    return (
        <PageWithTitleLayout title='管理者設定'>
            <TabContext value={tabValue}>
                <Box sx={{ borderBottom: 1, borderColor: 'divider' }}>
                    <TabList 
                        onChange={(e, newValue) => { 
                            history.push(PATHS.adminSettings + newValue); 
                            setTabValue(newValue)
                        }}
                        variant="scrollable"
                        scrollButtons="auto"
                    >
                        <Tab label="ユーザー情報" value="userManagement" />
                        <Tab label="店舗情報" value="storeManagement" />
                        <Tab label="HLG管理" value="hlg" />
                    </TabList>
                </Box>
                <Switch>
                    <Route exact path={PATHS.adminUserManagements} component={AdminUserManagements} />
                    <Route exact path={PATHS.adminStoreManagements} component={AdminStoreManagements} />
                    <Route exact path={PATHS.adminHLG} component={AdminHLG} />
                    <Route exact path={PATHS.adminStoreBulkUpload} component={AdminStoreBulkUpload} />
                    <Route exact path={PATHS.adminStoreUserList} component={AdminUserManagementList} />
                    <Route path={PATHS.adminUserManagementEdit} component={AdminUserManagementEdit} />
                    <Route path={PATHS.adminUserBulkUpload} component={AdminUserBulkUpload} />
                </Switch>
            </TabContext>
        </PageWithTitleLayout>
    );
}

export default AdminSettings;

